import { isConnected, getSession, onConnect } from '../../em-shared-session/src/connection';
/**
 * Additional Handlers
 */
let handlersIndex = 0;
const onTxHandlers = {};
const onRxHandlers = {};

// Logic to attach a handler
function addHandler(handlers = {}, fn = () => {}) {
    const handlerIndex = ++handlersIndex;
    const targetHandlers = handlers;
    targetHandlers[handlerIndex] = fn;
    return () => {
        delete targetHandlers[handlerIndex];
    };
}

// Logic to call all attached handlers
function callHandlers(handlers = {}, params = []) {
    for (const handlerIndex of Object.keys(handlers)) {
        if (typeof handlers[handlerIndex] === 'function') {
            handlers[handlerIndex](...params);
        }
    }
}


/**
 * Attach callHandlers to session
 */
function attachHandlers() {
    const session = getSession();
    if (!session) {
        return false;
    }

    const socket = '_socket';
    if (session && session[socket]) {
        if (typeof session[socket].onmessage === 'function') {
            const onmessage = session[socket].onmessage;
            session[socket].onmessage = (...params) => {
                onmessage(...params);
                callHandlers(onRxHandlers, params);
            };
        }

        if (typeof session[socket].send === 'function') {
            const send = session[socket].send;
            session[socket].send = (...params) => {
                send(...params);
                callHandlers(onTxHandlers, params);
            };
        }
    }

    return true;
}
onConnect(() => attachHandlers());
if (isConnected()) {
    attachHandlers();
}

/**
 * onTx - On data transmitted
 */
export function onTx(fn) {
    return addHandler(onTxHandlers, fn);
}


/**
 * onRx = On data received
 */
export function onRx(fn) {
    return addHandler(onRxHandlers, fn);
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/tx-rx.js